module.exports = __webpack_public_path__ + "img/doc.4e7d478f.svg";